//import firebase from 'firebase/app';
//import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import 'firebase/analytics';
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
    apiKey: "AIzaSyCJdOAMgsfIJ7YqGllePlMOh36N74EpZik",
    authDomain: "dev-zyvora.firebaseapp.com",
    projectId: "dev-zyvora",
    storageBucket: "dev-zyvora.appspot.com",
    messagingSenderId: "601728655712",
    appId: "1:601728655712:web:a96b772ba53788371ffe05",
    measurementId: "G-1GRMTXRNPJ"
  };
  
  // Initialize Firebase
  //const app = initializeApp(firebaseConfig);
  //const analytics = getAnalytics(app);
  //firebaseConfig.initializeApp(firebaseConfig);
  //firebaseConfig.analytics();
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { app, analytics, auth };